// Constant Data that related to Seller Outbound Return domain

export const STATUS = {
  PENDING         : 'pending',
  SCHEDULED       : 'scheduled',
  SELLER_RECEIVED : 'seller_received'
}

export const RETURN_TYPE = {
  REJECTED               : 'rejected',
  AGED                   : 'aged',
  SELLER_REQUESTED       : 'seller_requested',
  DONATED                : 'donated',
  REFUNDED               : 'refunded',
  BANNED                 : 'banned',
  PRICE_CONFIRM_DEADLOCK : 'price_confirm_deadlock'
}

export const EMAIL_STATUS = {
  NOT_SENT : 'not_sent',
  SENT     : 'sent'
}


/** Exclude rejected return type */
export const NON_REJECTED_RETURN_TYPE = {
  [RETURN_TYPE.AGED.toUpperCase()]             : RETURN_TYPE.AGED,
  [RETURN_TYPE.SELLER_REQUESTED.toUpperCase()] : RETURN_TYPE.SELLER_REQUESTED,
  [RETURN_TYPE.DONATED.toUpperCase()]          : RETURN_TYPE.DONATED,
  [RETURN_TYPE.REFUNDED.toUpperCase()]         : RETURN_TYPE.REFUNDED,
  [RETURN_TYPE.BANNED.toUpperCase()]           : RETURN_TYPE.BANNED
}

export const COURIER = {
  SELLER     : 'seller',
  EASYPARSEL : 'easyparcel',
  TIKI       : 'tiki',
  JNE        : 'jne',
  GRAB       : 'grab',
  GOJEK      : 'gojek',
  SICEPAT    : 'sicepat',
  KGEXPRESS  : 'kgexpress'
}

/** Exclude Seller as courier service */
export const COURIER_DELIVERY_SERVICE = {
  [COURIER.EASYPARSEL.toUpperCase()] : COURIER.EASYPARSEL,
  [COURIER.TIKI.toUpperCase()]       : COURIER.TIKI,
  [COURIER.JNE.toUpperCase()]        : COURIER.JNE,
  [COURIER.GRAB.toUpperCase()]       : COURIER.GRAB,
  [COURIER.GOJEK.toUpperCase()]      : COURIER.GOJEK,
  [COURIER.SICEPAT.toUpperCase()]    : COURIER.SICEPAT,
  [COURIER.KGEXPRESS.toUpperCase()]  : COURIER.KGEXPRESS
}

export const SHIPMENT_TYPE = {
  REGULER       : 'reguler',
  SAME_DAY      : 'same_day',
  SELLER_PICKUP : 'seller_pickup',
  ECONOMY       : 'economy'
}

/** Shipment type only if courier is not seller */
export const NON_SELLER_SHIPMENT_TYPE = {
  [SHIPMENT_TYPE.REGULER.toUpperCase()]  : SHIPMENT_TYPE.REGULER,
  [SHIPMENT_TYPE.SAME_DAY.toUpperCase()] : SHIPMENT_TYPE.SAME_DAY,
  [SHIPMENT_TYPE.ECONOMY.toUpperCase()]  : SHIPMENT_TYPE.ECONOMY
}

/** Shipment type only if courier is seller */
export const SELLER_SHIPMENT_TYPE = {
  [SHIPMENT_TYPE.SELLER_PICKUP.toUpperCase()]: SHIPMENT_TYPE.SELLER_PICKUP
}